import React, {useEffect} from 'react';
import Main from 'screens/mainViews/main/Main';
import {BrowserRouter} from 'react-router-dom';
import {createTheme, MuiThemeProvider} from '@material-ui/core';
import {jssPreset, StylesProvider} from "@material-ui/styles";
import {create} from "jss";
import rtl from "jss-rtl";
import {useMediaQuery} from "react-responsive";
import {deviceQuery1, deviceQuery2} from "components/utils/UiUtils";
import {callApi} from "./connection/ClientApi";
import Urls from "./connection/Urls";
import {v4 as uuidv4} from 'uuid';

export default function App() {

    const [key, setKey] = React.useState(1);
    const mediaQuery1 = useMediaQuery(deviceQuery1);
    const mediaQuery2 = useMediaQuery(deviceQuery2);

    const jss = create({plugins: [...jssPreset().plugins, rtl()]});
    const THEME = createTheme({
        direction: "rtl",
        typography: {
            "fontFamily": 'FontAwesome'
        },
    });

    function requestSetCustomerBehaviour() {
        let guid = localStorage.getItem("customerBehaviourGuid");
        if (!(guid && guid.length > 0)) {
            guid = uuidv4();
            localStorage.setItem("customerBehaviourGuid", guid);
        }

        let params = new FormData()
        params.append("guid", guid)
        params.append("action", window.location.href)
        callApi(Urls.insertCustomerBehaviour, params)
    }

    useEffect(() => {
        setKey(Math.random() * 1000)
        requestSetCustomerBehaviour()
    }, [mediaQuery1, mediaQuery2])

    return (
        <StylesProvider jss={jss}>
            <MuiThemeProvider theme={THEME}>
                <BrowserRouter>
                    <Main key={key}/>
                </BrowserRouter>
            </MuiThemeProvider>
        </StylesProvider>
    );

}